import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  error,
  success,
} from "../../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../../components/buttons/Button";
import CTextField from "../../../../../components/inputBoxes/text-input";
import CUrlField from "../../../../../components/inputBoxes/url-input";
import CSingleFileUpload from "../../../../../components/uploadFields/singleFileUpload";
import { LoadingContext } from "../../../../../context/loadingContext";
import {
  SignUpPopularityHooks,
  SignUpPopularityUpdateHooks,
} from "../../hooks/useSignup";

const RegPopularity = (props) => {
  const { setLoading } = useContext(LoadingContext);
  const { portal_id } = useParams();
  const dispatch = useDispatch();
  const SocailMediaReducer = useSelector(
    (state) => state.BusinessSocailMediaReducer
  );

  const [FieldsValue, setFieldsValue] = useState({});
  let fileUpload = {};
  let formData = new FormData();

  const FileUploadHandle = (fieldname, file) => {
    const blob = file.slice(0, file.size, file.type);
    const fileName = Math.floor(Math.random() * 10000000000) + "-" + file.name;
    const folderName = "Marketplace-development";
    const newFile = new File([blob], fileName, {
      type: file.type,
    });
    formData.append("filePermission", "private");
    formData.append("foldername", folderName);
    formData.append("files", newFile);
    fileUpload = {
      bucket: "next99",
      key: folderName + "/" + fileName,
    };
  };

  // Popularity data register in registration page using SignUpPopularityHooks

  const popularityHandle = async () => {
    setLoading(true);
    const res = await SignUpPopularityHooks(FieldsValue, formData, fileUpload);
    setLoading(false);
    if (res.status === 200) {
      dispatch({ type: "BUSINESS_SOCIAL_DONE" });
      document.getElementById("pills-statistics-tab").click();
      success("Popularity Data created successfully");
    } else {
      error(res.message);
    }
  };

  const HandleFieldsValue = (key, value) => {
    setFieldsValue({ ...FieldsValue, [key]: value });
  };

  // Update popularity page data using SignUpPopularityUpdateHooks

  const popularityUpdateHandle = async () => {
    if (Object.keys(fileUpload).length) {
      setLoading(true);
      const data = {
        mpi_id: Number(portal_id),
        updateData: FieldsValue,
      };
      const result = await SignUpPopularityUpdateHooks(
        data,
        formData,
        fileUpload
      );
      setLoading(false);
      if (result.status === 200) {
        document.getElementById("pills-statistics-tab").click();
        success("Popularity Data Updated successfully");
      } else {
        error(result.message);
      }
    } else {
      document.getElementById("pills-statistics-tab").click();
    }
  };

  const submit = (event) => {
    event.preventDefault();
    if (props.regPage === "update-new-business") {
      popularityUpdateHandle();
    } else {
      if (SocailMediaReducer === 0) popularityHandle();
      else document.getElementById("pills-statistics-tab").click();
    }
  };

  return (
    <>
      <div className="container">
        <div className="row mb-4">
          <div className="col-4"></div>
          <div className="col-md-4 col-sm-12">
            <form onSubmit={submit}>
              <CSingleFileUpload
                required={
                  props.regPage === "update-new-business" ? false : true
                }
                labelName={"Google Analytics Report-Last 30 Days"}
                name={"google_Analytics"}
                customClassInput={"bg-primary-soft"}
                customClassDiv={"text-dark"}
                acceptListArray={[
                  "application/pdf",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.ms-excel",
                ]}
                functionName={(name, google_Analytics) =>
                  FileUploadHandle(name, google_Analytics)
                }
                defaultvalue={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_socialmedia"
                  ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                        "data_pub_socialmedia"
                      ][0]["ga_analytics"].split("-")[2]
                    : ""
                }
              />
              <small className="text-dark">(Accept only .pdf or .xlsx)</small>
              <CUrlField
                customClassDiv={"mb-4 mt-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                labelName={"Facebook URL"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_socialmedia"
                  ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                        "data_pub_socialmedia"
                      ][0]["facebook_url"]
                    : ""
                }
                name={"facebook_url"}
                pattern={
                  "http://www.facebook.com/(.+)|https://www.facebook.com/(.+)|https://facebook.com/(.+)|https://facebook.com/(.+)"
                }
                functionName={(name, facebook) =>
                  HandleFieldsValue(name, facebook)
                }
              />
              <CTextField
                labelName={"Instagram Handle"}
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                name={"instagram_url"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_socialmedia"
                  ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                        "data_pub_socialmedia"
                      ][0]["instagram_url"]
                    : ""
                }
                pattern={
                  "http://www.instagram.com/(.+)|https://www.instagram.com/(.+)|https://instagram.com/(.+)|https://instagram.com/(.+)"
                }
                functionName={(name, instagram) =>
                  HandleFieldsValue(name, instagram)
                }
              />
              <CUrlField
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_socialmedia"
                  ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                        "data_pub_socialmedia"
                      ][0]["twitter_url"]
                    : ""
                }
                labelName={"Twitter URL"}
                name={"twitter_url"}
                pattern={
                  "http://www.twitter.com/(.+)|https://www.twitter.com/(.+)|http://twitter.com/(.+)|https://twitter.com/(.+)"
                }
                functionName={(name, twitter) =>
                  HandleFieldsValue(name, twitter)
                }
              />
              <CUrlField
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                labelName={"LinkedIn URL"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_socialmedia"
                  ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                        "data_pub_socialmedia"
                      ][0]["linkedin_url"]
                    : ""
                }
                name={"linkedin_url"}
                pattern={
                  "http://www.linkedin.com/(.+)|https://www.linkedin.com/(.+)|https://linkedin.com/(.+)|https://linkedin.com/(.+)"
                }
                functionName={(name, linkedIn) =>
                  HandleFieldsValue(name, linkedIn)
                }
              />
              <CButton
                btnClassesDiv={"text-center"}
                btnClasses={"btn px-4 fw-bold text-white"}
                IsOutline={false}
                innertext={"Next"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
              />
            </form>
          </div>
          <div className="col-4"></div>
        </div>
      </div>
    </>
  );
};

export default RegPopularity;